import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function BackToTop() {
  const [scrolled, setScrolled] = useState(false);
  const { isOpen } = useCart();
  const visible = scrolled && !isOpen;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 350);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      data-testid="back-to-top-button"
      onClick={scrollTop}
      aria-label="Remonter en haut de la page"
      className={`fixed bottom-6 right-6 z-[60] flex h-12 w-12 items-center justify-center rounded-full bg-amber-deep text-white shadow-lg shadow-amber-900/25 transition-all duration-300 hover:bg-honey hover:-translate-y-0.5 active:scale-95 ${
        visible ? "pointer-events-auto opacity-100 translate-y-0" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <ArrowUp size={20} />
    </button>
  );
}
